import React, { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { useLazyMeQuery } from '../features/api/authEndpoints'
import { logout, setAdmin, setAuthHydrated } from '../store/authSlice'

export default function ProtectedRoute({ children }) {
  const token = useSelector((s) => s.auth.token)
  const admin = useSelector((s) => s.auth.admin)
  const authHydrated = useSelector((s) => s.auth.authHydrated)
  const dispatch = useDispatch()
  const location = useLocation()
  const [fetchMe] = useLazyMeQuery()

  useEffect(() => {
    if (!token) {
      dispatch(setAuthHydrated(true))
      return undefined
    }
    if (admin) {
      dispatch(setAuthHydrated(true))
      return undefined
    }
    dispatch(setAuthHydrated(false))
    let cancelled = false
    ;(async () => {
      try {
        const data = await fetchMe().unwrap()
        if (!cancelled) {
          dispatch(setAdmin(data))
        }
      } catch {
        if (!cancelled) {
          dispatch(logout())
        }
      }
    })()
    return () => {
      cancelled = true
    }
  }, [token, admin, fetchMe, dispatch])

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (!authHydrated) {
    return (
      <Box minHeight="40vh" display="flex" alignItems="center" justifyContent="center">
        <CircularProgress size={28} />
      </Box>
    )
  }

  return children
}
